<template>
  <div class="pageContainer">
    <div class="container">
      <div class="row">
        <div id="EditGoalWrapper" class="d-none col-12 col-sm-8 col-md-6 col-lg-4 mx-auto">
          <div class="header">
            <h1>Edit Goal</h1>
            <p class="lead">Add a new goal to work towards!</p>
          </div>
          <form @submit.prevent="EditGoal">
            <div class="form-group">
              <label for="inputFirst">Title</label>
              <input type="text" class="form-control" id="inputFirst" placeholder="Title" autofocus="autofocus" v-model="title">
            </div>
            <div class="form-group">
              <label for="inputLast">Description</label>
              <input type="text" class="form-control" id="desc" placeholder="Description" v-model="description">
            </div>
            <div class="form-group">
              <label for="exampleFormControlSelect1">Category</label>
              <select v-model="category" class="form-control" id="exampleFormControlSelect1">
                <option v-for="category in categoryOptions" v-bind:value="category.value">
                  {{ category.text }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label for="inputFirst">Hashtags</label>
              <ul class="list-inline tagsList">
                <li class="list-inline-item" v-for="hashtag in hashtags"><span class="badge badge-secondary">{{ hashtag }} <i class="fa fa-close" @click.prevent="removeHashtag(hashtag)"></i></span></li>
              </ul>
              <input type="text" @keydown.enter.prevent="addHashtag" class="form-control" id="inputFirst" placeholder="Add a hashtag" autofocus="autofocus" v-model="newHashtag">
              <small id="passwordHelpBlock" class="form-text text-muted">Press ENTER to add each tag.</small>
            </div>
            <div class="form-group">
              <label for="inputLast">Weekly Goal</label>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="frequencyGoal1" value="1" v-model="frequency">
                <label class="form-check-label" for="frequencyGoal1">1</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="frequencyGoal2" value="2" v-model="frequency">
                <label class="form-check-label" for="frequencyGoal2">2</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="frequencyGoal3" value="3" v-model="frequency">
                <label class="form-check-label" for="frequencyGoal3">3</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="frequencyGoal4" value="4" v-model="frequency">
                <label class="form-check-label" for="frequencyGoal4">4</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="frequencyGoal5" value="5" v-model="frequency">
                <label class="form-check-label" for="frequencyGoal5">5</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="frequencyGoal6" value="6" v-model="frequency">
                <label class="form-check-label" for="frequencyGoal6">6</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="frequencyGoal7" value="7" v-model="frequency">
                <label class="form-check-label" for="frequencyGoal7">7</label>
              </div>
              <small id="passwordHelpBlock" class="form-text text-muted">How many days per week do you want to achieve this?</small>
            </div>
            <div class="form-group">
              <label for="exampleFormControlSelect1">Who can see this goal?</label>
              <select v-model="privacy.type" class="form-control" id="exampleFormControlSelect1">
                <option v-for="option in privacyOptions" v-bind:value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>
            <button type="submit" class="btn btn-primary">Edit Goal</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import moment from 'moment'
import db from '@/store/firebaseinit'
import Navbar from '@/components/utility/Navbar'

export default {
  name: 'EditGoal',
  components: {
    Navbar,
  },
  data() {
    return {
      user: null,
      feedback: null,
      title: null,
      description: null,
      newHashtag: null,
      hashtags: [],
      frequency: 4,
      frequencyMet: null,
      categoryOptions: [
        { text: 'Career', value: 0 },
        { text: 'Diet', value: 1 },
        { text: 'Finance', value: 2 },
        { text: 'Fitness', value: 3 },
        { text: 'Fun', value: 4 },
        { text: 'Health', value: 5 },
        { text: 'Intellect', value: 6 },
        { text: 'Relationships', value: 7 },
        { text: 'Spiritual', value: 8 },
        { text: 'Travel', value: 9 },
        { text: 'Volunteer', value: 10 },
      ],
      category: 0,
      privacyOptions: [
        { text: 'Public', value: 0 },
        { text: 'Friends', value: 1 },
        { text: 'Only Me', value: 2 },
        { text: 'Select Friends', value: 3 },
      ],
      privacy: {
        friends: null,
        type: null
      },
      thisWeek: null,
    }
  },
  beforeCreate() {
    var user = firebase.auth().currentUser
    db.collection('users').doc(user.uid).get()
    .then(snapshot => {
      this.user = snapshot.data()
    }).catch(error => {
      console.log(error.message)
    })
    db.collection('goals').doc(this.$route.params.id).get()
    .then(snapshot => {
      if(user.uid != snapshot.data().userId) {
        this.$router.push({ name: 'Error404' })
      } else {
        this.category = snapshot.data().category
        this.userId = snapshot.data().userId
        this.description = snapshot.data().description
        this.title = snapshot.data().title
        this.hashtags = snapshot.data().hashtags
        this.frequency = snapshot.data().frequencyGoal
        this.privacy.friends = snapshot.data().privacy.friends
        this.privacy.type = snapshot.data().privacy.type
        this.thisWeek = snapshot.data().thisWeek
        this.frequencyMet = snapshot.data().frequencyMet
        $('#EditGoalWrapper').removeClass('d-none')
      }
    }).catch(error => {
      console.log(error.message)
    })
  },
  methods: {
    EditGoal() {
      if(this.title) {
        var mondayCalc = moment().format('d') - 1
        var weekStart = moment().add(-mondayCalc, 'days').format('YYYY-MM-DD')
        var uid = firebase.auth().currentUser.uid
        db.collection('goals').doc(this.$route.params.id).update({
          title: this.title,
          description: this.description,
          privacy: {
            friends: this.privacy.friends,
            type: this.privacy.type
          },
          frequencyGoal: this.frequency,
          frequencyMet: this.frequencyMet,
          userId: uid,
          hashtags: this.hashtags,
          category: this.category,
          thisWeek: this.thisWeek
        }).then(() => {
          this.$router.push({ name: 'Profile', params: { username: this.user.username } })
        }).catch(error => {
          console.log(error)
        })
      }
    },
    addHashtag() {
      if(!this.hashtags.includes(this.newHashtag)) {
        var cleanHashtag = this.newHashtag
        cleanHashtag = cleanHashtag.replace(/[&\/\\#!,+()$~%.'":*?<>{}]/g, '');
        this.hashtags.push(cleanHashtag)
      }
      this.newHashtag = ''
    },
    removeHashtag(hashtagName) {
      this.hashtags = this.hashtags.filter(hashtag => {
        return hashtag != hashtagName
      })
    },
  }
}
</script>

<style scoped lang="css">
.header {
  text-align: center;
  margin: 15px 0 0 0;
}
label {
  display: block;
}
.fa-close:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/goals/EditGoal.vue